import React, { useState, useEffect } from 'react';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  
  const [formStatus, setFormStatus] = useState({
    submitted: false,
    success: false,
    error: false,
    message: ''
  });

  useEffect(() => {
    document.title = "Contact Us | TravelMaker - Audio Guide & Travel Companion";
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', "Have questions about TravelMaker - your audio guide and travel companion? Contact us for support, partnerships, or feedback.");
  }, []); // Empty dependency array means this runs once on mount
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };
  
  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Basic validation
    if (!formData.name || !formData.email || !formData.message) {
      setFormStatus({
        submitted: true,
        success: false,
        error: true,
        message: 'Please fill in all required fields.'
      });
      return;
    }
    
    // Create mailto link
    const subject = formData.subject || 'Contact Form Submission';
    const body = `Name: ${formData.name}\nEmail: ${formData.email}\n\nMessage:\n${formData.message}`;
    const mailtoLink = `mailto:info@travelmaker.app?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    
    // Open email client
    window.location.href = mailtoLink;
    
    // Show success message
    setFormStatus({
      submitted: true,
      success: true,
      error: false,
      message: 'Opening your email client to send the message...'
    });
  };
  
  return (
    <div className="max-w-3xl mx-auto py-10 px-5">
      <div className="flex flex-col gap-10">
        <div className="text-center p-8 bg-gradient-to-br from-primary to-primary-dark rounded-2xl text-white">
          <h3 className="text-2xl mb-1 text-white font-semibold">Get in touch with TravelMaker</h3>
          <p className="text-white/90 leading-relaxed text-lg">
            Kolpo LTD<br />
            Email: info@travelmaker.app<br />
          </p>
        </div>
        
        <form 
          onSubmit={handleSubmit}
          className="bg-white p-10 rounded-2xl shadow-xl border border-primary/10"
        >
          {formStatus.success && (
            <div className="bg-green-100 text-green-800 p-4 rounded-md mb-5">
              {formStatus.message}
            </div>
          )}
          
          {formStatus.error && (
            <div className="bg-red-100 text-red-800 p-4 rounded-md mb-5">
              {formStatus.message}
            </div>
          )}
          
          <div className="mb-5">
            <label htmlFor="name" className="block mb-2 font-medium text-gray-800">
              Name *
            </label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              className="w-full py-3 px-4 border border-gray-300 rounded-md text-base transition-colors duration-300 focus:border-primary focus:outline-none"
            />
          </div>
          
          <div className="mb-5">
            <label htmlFor="email" className="block mb-2 font-medium text-gray-800">
              Email *
            </label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              className="w-full py-3 px-4 border border-gray-300 rounded-md text-base transition-colors duration-300 focus:border-primary focus:outline-none"
            />
          </div>
          
          <div className="mb-5">
            <label htmlFor="subject" className="block mb-2 font-medium text-gray-800">
              Subject
            </label>
            <input
              type="text"
              id="subject"
              name="subject"
              value={formData.subject}
              onChange={handleChange}
              className="w-full py-3 px-4 border border-gray-300 rounded-md text-base transition-colors duration-300 focus:border-primary focus:outline-none"
            />
          </div>
          
          <div className="mb-5">
            <label htmlFor="message" className="block mb-2 font-medium text-gray-800">
              Message *
            </label>
            <textarea
              id="message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              required
              className="w-full py-3 px-4 border border-gray-300 rounded-md text-base min-h-[150px] resize-y transition-colors duration-300 focus:border-primary focus:outline-none"
            />
          </div>
          
          <button 
            type="submit"
            className="bg-primary text-white py-3 px-6 border-none rounded-md text-base font-semibold cursor-pointer transition-colors duration-300 hover:bg-primary-dark disabled:bg-gray-400 disabled:cursor-not-allowed"
          >
            Send Message
          </button>
        </form>
      </div>
    </div>
  );
};

export default Contact;